import React, { Component } from 'react';
import withWrapper from '../../helpers/withWrapper';

class Fairflow extends Component {

    state = {
    };

    async componentDidMount() {}

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen pt-20 sm:pt-14" style={{ backgroundColor: "#303749" }}>
                <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                    <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                        <div className="flex flex-col items-center justify-center w-full max-w-4xl mx-auto p-8">
                            {/* Content Box */}
                            <div style={{ 
                                backgroundColor: "rgba(0,0,0,0.5)", 
                                borderRadius: "20px", 
                                padding: "40px",
                                border: "1px solid rgba(255,255,255,0.08)",
                                boxShadow: "0 20px 60px rgba(0,0,0,0.5)"
                            }} 
                            className="w-full text-center">
                                
                                {/* Header with Logo - Flex Row */}
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                    marginBottom: "20px"
                                }}>
                                    {/* Welcome Heading */}
                                    <h1 style={{ 
                                        fontSize: "clamp(28px, 5vw, 48px)", 
                                        fontWeight: "bold",
                                        background: "linear-gradient(135deg, #FFD700, #FF6B35, #FF1493, #00D4FF)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        margin: 0
                                    }}>
                                        Welcome to FairFlow
                                    </h1>
                                    
                                    {/* Logo on the Right */}
                                    <img 
                                        src="/logo/logofff.png" 
                                        alt="FairFlow Logo"
                                        style={{
                                            width: "clamp(60px, 8vw, 100px)",
                                            height: "auto",
                                            objectFit: "contain",
                                            filter: "drop-shadow(0 4px 20px rgba(255,215,0,0.3))"
                                        }}
                                    />
                                </div>
                                
                                {/* Subtitle */}
                                <p style={{ 
                                    fontSize: "clamp(14px, 2vw, 20px)", 
                                    color: "#00FF88",
                                    marginBottom: "15px",
                                    fontWeight: "600"
                                }}>
                                    Decentralized Platform on Polygon Blockchain
                                </p>
                                
                                {/* Divider */}
                                <div style={{ 
                                    width: "80px", 
                                    height: "3px", 
                                    background: "linear-gradient(90deg, #FFD700, #FF6B35, #FF1493, #00D4FF)",
                                    margin: "20px auto",
                                    borderRadius: "2px"
                                }}></div>
                                
                                {/* Main Info with USDT Icon */}
                                <div style={{ 
                                    background: "rgba(255,255,255,0.05)", 
                                    borderRadius: "15px", 
                                    padding: "25px",
                                    marginBottom: "25px"
                                }}>
                                    <p style={{ 
                                        fontSize: "clamp(16px, 2.2vw, 24px)", 
                                        color: "#FFFFFF",
                                        lineHeight: "1.8",
                                        fontWeight: "400",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "10px",
                                        flexWrap: "wrap"
                                    }}>
                                        <img 
                                            src="/logo/USDTcoin.png" 
                                            alt="USDT"
                                            style={{
                                                width: "clamp(30px, 3vw, 45px)",
                                                height: "auto",
                                                objectFit: "contain"
                                            }}
                                        />
                                        <span style={{ color: "#FFD700", fontWeight: "bold" }}>Investment by USDT</span> 
                                        {" "}and get return{" "}
                                        <span style={{ color: "#00FF88", fontWeight: "bold" }}>130%</span>
                                        {" "}included principal
                                    </p>
                                </div>
                                
                                {/* Requirements Box */}
                                <div style={{ 
                                    display: "flex", 
                                    flexWrap: "wrap", 
                                    justifyContent: "center", 
                                    gap: "15px",
                                    margin: "20px 0"
                                }}>
                                    <div style={{ 
                                        background: "rgba(255,215,0,0.12)", 
                                        border: "1px solid rgba(255,215,0,0.2)",
                                        borderRadius: "12px", 
                                        padding: "12px 25px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}>
                                        <span style={{ fontSize: "24px" }}>⭐</span>
                                        <span style={{ color: "#FFD700", fontWeight: "600" }}>Rank #5 Required</span>
                                    </div>
                                    <div style={{ 
                                        background: "rgba(0,255,136,0.12)", 
                                        border: "1px solid rgba(0,255,136,0.2)",
                                        borderRadius: "12px", 
                                        padding: "12px 25px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}>
                                        <span style={{ fontSize: "24px" }}>💵</span>
                                        <span style={{ color: "#00FF88", fontWeight: "600" }}>Minimum 5 USDT</span>
                                    </div>
                                    <div style={{ 
                                        background: "rgba(0,212,255,0.12)", 
                                        border: "1px solid rgba(0,212,255,0.2)",
                                        borderRadius: "12px", 
                                        padding: "12px 25px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}>
                                        <span style={{ fontSize: "24px" }}>🟣</span>
                                        <span style={{ color: "#00D4FF", fontWeight: "600" }}>Polygon Blockchain</span>
                                    </div>
                                </div>
                                
                                {/* Divider */}
                                <div style={{ 
                                    width: "100%", 
                                    height: "1px", 
                                    background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)",
                                    margin: "25px 0"
                                }}></div>
                                
                                {/* JOIN Button */}
                                <a 
                                    href="https://fairflow.fund" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    <button
                                        style={{
                                            background: "linear-gradient(90deg, #FFD700, #00FF00, #FF0000, #0066FF, #FFD700)",
                                            backgroundSize: '400% 100%',
                                            animation: "gradientMove 3s ease infinite",
                                            border: 'none',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            fontSize: 'clamp(20px, 2.5vw, 32px)',
                                            padding: '18px 60px',
                                            borderRadius: '50px',
                                            cursor: 'pointer',
                                            textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                            boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            letterSpacing: '2px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            width: '100%',
                                            maxWidth: '350px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(255,215,0,0.3)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.4)';
                                        }}
                                    >
                                        🚀 JOIN NOW
                                    </button>
                                </a>
                                
                                {/* Additional Info */}
                                <p style={{ 
                                    color: "#888888", 
                                    fontSize: "clamp(12px, 1.2vw, 16px)",
                                    marginTop: "20px"
                                }}>
                                    <span style={{ color: "#FFD700" }}>✦</span>{" "}
                                    Secure • Transparent • Decentralized{" "}
                                    <span style={{ color: "#FFD700" }}>✦</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Global CSS for animation */}
                <style>
                    {`
                        @keyframes gradientMove {
                            0% {
                                background-position: 0% 50%;
                            }
                            50% {
                                background-position: 100% 50%;
                            }
                            100% {
                                background-position: 0% 50%;
                            }
                        }
                    `}
                </style>
            </div>
        );
    }
}

export default withWrapper(Fairflow);